import { CoreActions, CoreActionsTypes } from '@bepatient/core';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TimelineActions, TimelineActionTypes } from './timeline.actions';
import {
  TimelineActivity,
  TimelineBlocker,
  TimelineDay,
  TimelineInfoMessage
} from './timeline.models';

interface TimelineState {
  blocker?: TimelineBlocker;
  days: Array<TimelineDay>;
  infoMessages: Array<TimelineInfoMessage>;
  blockers: Array<TimelineBlocker>;
}

export const timelineInitialState: TimelineState = {
  days: undefined,
  infoMessages: [],
  blockers: []
};

export function timelineReducer(
  state = timelineInitialState,
  action: CoreActions | TimelineActions
): TimelineState {
  switch (action.type) {
    case CoreActionsTypes.LOGOUT:
    case TimelineActionTypes.LOAD_TIMELINE:
      return {
        ...timelineInitialState
      };

    case TimelineActionTypes.LOAD_TIMELINE_SUCCESS:
      return {
        blocker: returnNextBlocker(
          action.payload.days,
          action.payload.infoMessages
        ),
        days: action.payload.days,
        infoMessages: action.payload.infoMessages,
        blockers: action.payload.blockers
      };

    case TimelineActionTypes.INFO_MESSAGE_DONE_SUCCESS:
      const updatedInfoMessages = state.infoMessages.filter(
        infoMessage => infoMessage.uuid !== action.payload.uuid
      );

      return {
        ...state,
        blocker: returnNextBlocker(state.days, updatedInfoMessages),
        infoMessages: updatedInfoMessages
      };

    default:
      return state;
  }

  function returnNextBlocker(
    days: Array<TimelineDay>,
    infoMessages: Array<TimelineInfoMessage>
  ): TimelineBlocker {
    const blocker: TimelineBlocker = {
      activity: days
        .reduce<TimelineActivity[]>(
          (acc, cur) => acc.concat(cur.activities),
          []
        )
        .filter(activity => activity.blocking)
        .sort((a, b) => b.blocking - a.blocking)
        .shift(),
      infoMessage: infoMessages
        .filter(infoMessage => infoMessage.blocking)
        .sort((a, b) => a.blocking - b.blocking)
        .shift()
    };

    return blocker.activity && blocker.infoMessage
      ? { infoMessage: blocker.infoMessage }
      : blocker.activity || blocker.infoMessage
      ? blocker
      : void 0;
  }
}

const timelineState = createFeatureSelector<TimelineState>('timeline');

export const selectorTimelineBlocker = createSelector(
  timelineState,
  state => state.blocker
);

export const selectorTimelineDays = createSelector(
  timelineState,
  state => state.days
);

export const selectorTimelineInfoMessages = createSelector(
  timelineState,
  state => state.infoMessages
);
